export default "__VITE_ASSET__m8yadLDh__"